import React, { useState, useEffect } from "react";

import { useQuery } from "@tanstack/react-query";
import axios from "axios";



export default function useGetPersonalAccountInfo() {
    const get = async () => {
        const response = await axios.get("/ArticlesApi/GetAllArticlesJson");

        console.log("%c GetAllArticlesJson данные:", "color: #b885f2; font-weight: bold; font-size: 16px;", response.data);
        return response.data.UpdatedItem;
    }

    const { data, error, isLoading, isError, isFetching, refetch } = useQuery({
        queryKey: ["GetAllArticlesJson"],
        queryFn: get,
        refetchOnWindowFocus: false,
    });

    return { data, error, isLoading, isFetching, isError, refetch }
}